import { isCapabilityEnabled } from 'owa-capabilities';
import { bleedThroughCapability } from 'owa-capabilities-definitions/lib/bleedThroughCapability';
import isMicaEffectEnabled from './isMicaEffectEnabled';

export default function isFullBleedEnabled(): boolean {
    // Full bleed is enabled if either the bleed through capability is enabled
    // or the mica effect is enabled
    return isCapabilityEnabled(bleedThroughCapability) || isMicaEffectEnabled();
}
